import { useState } from "react";
import {
    Avatar,
    Box,
    Button,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    TextField,
    Toolbar,
    Typography
} from "@mui/material";
import { Close, MoreVert } from "@mui/icons-material";
import Message from "./components/Message";
import useScreenSize from "../../../../hooks/useScreenSize";
import { statratRed, statratBlack } from "../../../../config/constants";

const fakeMessages = [
    {name: "Fadi Hareth", avatar: "F", header: "Joining the Blue Jays", message: "Yeah I have a LouisVille Slugger bat and Shoeless Joe glove"},
    {name: "Blake Stone", avatar: "B", header: "Left hand throw practice", message: "I got a exit velocity of 101mph, they get sent flying."}
];

const Messages = () => {
    const screenSize = useScreenSize();
    const [messages, setMessages] = useState(fakeMessages);
    const [currMessage, setCurrMessage] = useState(null);

    function filterMessages(search) {
        if (search === "") {
            setMessages(fakeMessages);
        } else {
            setMessages(fakeMessages.filter((message) => {
                return message.name.toLowerCase().includes(search) || message.header.toLowerCase().includes(search);
            }))
        }
    }
    
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'left',
                gap: 3,
                margin: 3
            }}
        >
            <Box display="flex" justifyContent="space-between" sx={{ alignItems: "end" }}>
                <Typography variant="h5">Messages</Typography>
            </Box>
            <Box display="flex" minWidth={1000} height={screenSize.height * 0.72}>
                <List sx={{
                    width: '100%',
                    overflow: 'auto',
                    maxWidth: 360,
                    padding: 0,
                    bgcolor: 'background.paper'
                }}>
                    <ListItem sx={{
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                        bgcolor: 'background.paper',
                        padding: 2,
                    }}>
                        <TextField
                            size="small"
                            fullWidth
                            placeholder="Search Messages"
                            onChange={(e) => filterMessages(e.target.value.toLowerCase())}
                        />
                    </ListItem>
                    {messages.map((message) => {
                        return <div key={message.name}>
                            <ListItem 
                                alignItems="flex-start"
                                sx={{ cursor: "pointer" }}
                                onClick={() => { setCurrMessage(message) }}
                            >
                                <ListItemAvatar>
                                    <Avatar alt={message.name}>{message.avatar}</Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={message.header}
                                    secondary={
                                        <>
                                        <Typography
                                            component="span"
                                            variant="body2"
                                            sx={{ color: 'text.primary', display: 'inline' }}
                                        >
                                            {message.name}
                                        </Typography>
                                        {" " + message.message}
                                        </>
                                    }
                                />
                            </ListItem>
                            <Divider variant="inset" component="li" />
                        </div>
                    })}
                </List>
                { currMessage !== null &&
                    <Box sx={{ width: '100%', overflow: 'auto', position: "relative" }}>
                        <Toolbar sx={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                            backgroundColor: statratRed,
                            justifyContent: "space-between"
                        }}>
                            <Typography variant="h5" color="#FFFFFF">{currMessage.header}</Typography>
                            <Box>
                                <IconButton><MoreVert /></IconButton>
                                <IconButton onClick={() => setCurrMessage(null)}><Close /></IconButton>
                            </Box>
                        </Toolbar>
                        <Message message={currMessage} fromUser={false} />
                        <Message message={{name: "Me", avatar: "M", message: "Wow you have all of these things?? That is crazy. So crazy it makes me want to write a long message for testing purposes! 🔥"}} fromUser={true} />
                        <Message message={{name: "Fadi Hareth", avatar: "F", message: "It's true! It's so true!"}} fromUser={false} />
                        <Message message={{name: "Fadi Hareth", avatar: "F", message: "And let me just reiterate for testing purposes..."}} fromUser={false} />
                        <Message message={{name: "Fadi Hareth", avatar: "F", message: "Where I have multiple messages in a row..."}} fromUser={false} />
                        <Message message={{name: "Fadi Hareth", avatar: "F", message: "just how true it is!!"}} fromUser={false} />
                        <Message message={{name: "Me", avatar: "M", message: "When you're right, you're right. I'm gonna say that a few more times now if that's okay. When you're right, you're right. When you're right, you're right. When you're right, you're right. When you're right, you're right. When you're right, you're right. When you're right, you're right. When you're right, you're right. When you're right, you're right. When you're right, you're right. When you're right, you're right. Okay that's enough thanks."}} fromUser={true} />
                        <Toolbar sx={{
                            position: "sticky",
                            width: '100%',
                            bottom: 0,
                            zIndex: 1,
                            backgroundColor: statratBlack
                        }}>
                            <TextField
                                size="small"
                                multiline
                                fullWidth
                                maxRows={4}
                                placeholder="Enter message"
                            />
                            <Button>SEND</Button>
                        </Toolbar>
                    </Box>
                }
            </Box>
        </Box>
    );
}

export default Messages;
